import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { IRootState } from "../../reducer/CombineReducer";
import { ProgressSpinner as UIProgressSpinner } from "../Common/UI/Index";
import "./Style.scss";

/**
 * Responsible for rendering the home component
 */
export const ProgressSpinner: React.FC = () => {

  const progressSpinnerData = useSelector((state: IRootState) => state.progressSpinnerData);
  const { t: translate } = useTranslation();

  return (
    progressSpinnerData && progressSpinnerData.show ?
      <div>
        <UIProgressSpinner
          delay={1}
          className="ebt-progress-spinner"
          text={translate(progressSpinnerData.text)}
          horizontal={true}
          size={"small"}
        />
      </div>
      : <></>
  );
};
